import React from 'react';
import './ComparisonTable.scss';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react';

import { Tab, Tabs } from './Tabs';
import { Transition } from './Transition';
import { TabsHeader } from './TabsHeader';
import { ComparisonContext } from './ComparisonContext';
import { Body } from './Body';
import { Header } from './Header';
import { Table } from './Table';
import { getHeaders } from './logic';

export interface ComparaisonTableProps {
  nbLigneHidden?: number;
  children: ReactNode;
  isSmall?: boolean;
  id?: string;
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>> | ((open: boolean) => void);
}
const ComparaisonTableComponent = ({
  nbLigneHidden = 5,
  children,
  isSmall,
  id = '',
  open = false,
  setOpen,
}: ComparaisonTableProps) => {
  const ref = useRef<any>(null);
  const [tableHeight, setTableHeight] = useState(0);
  const [sticky, setSticky] = useState(false);
  const [maxHeight, setMaxHeight] = useState<number | 'auto'>('auto');

  useEffect(() => {
    const elt = ref.current;

    const observer = new ResizeObserver((entries) => {
      const _recttable = entries[0].contentRect;

      setTableHeight(_recttable.height);
    });

    observer.observe(elt);

    return () => observer.unobserve(elt);
  }, []);

  useEffect(() => {
    const listenScroll = () => {
      if (ref && tableHeight !== 0) {
        const elt: HTMLDivElement | any = ref.current;
        const header: HTMLDivElement = elt?.querySelector(
          '.ComparisonTableHeader.notSticky',
        );

        const rectheader = header.getBoundingClientRect();
        const rectbody = elt.getBoundingClientRect();

        let verifSticky = true;

        if (rectbody.y + tableHeight - rectheader.height < 0) {
          verifSticky = false;
        }
        if (rectbody.y > 0) {
          verifSticky = false;
        }

        setSticky(verifSticky);
      }
    };

    window.addEventListener('scroll', listenScroll);

    return () => {
      window.removeEventListener('scroll', listenScroll);
    };
  }, [ref, sticky, tableHeight]);

  const heightGradiantTransition = nbLigneHidden * 60;
  const topGradiantTransition = (isSmall ? 100 : 160) + 53 + 24;

  return (
    <ComparisonContext.Provider
      value={{
        open,
        sticky,
        setOpen,
        heightGradiantTransition,
        maxHeight,
        setMaxHeight,
        topGradiantTransition,
      }}
    >
      <div
        id={id}
        ref={ref}
        className="ComparisonTable relative h-full overflow-hidden transition-all duration-[2000ms]"
        style={{
          maxHeight: open ? 'none' : maxHeight,
        }}
      >
        {children}
      </div>
    </ComparisonContext.Provider>
  );
};

export const ComparisonTable = Object.assign(ComparaisonTableComponent, {
  Tabs,
  Tab,
  Transition,
  TabsHeader,
  Body,
  Header,
  Table,
  getHeaders,
});
